module.exports = __webpack_public_path__ + "jpg/appGallery.jpg?f8927aa7129d62717b34614caf14f236";